import {Box, Button, HStack, Select, useTheme} from '@chakra-ui/react'
import {faCircleQuestion} from '@fortawesome/pro-regular-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import Trans from 'next-translate/Trans'
import useTranslation from 'next-translate/useTranslation'
import {useIsMobile} from '../../hooks/useIsMobile'
import {useSkill} from '../../hooks/useSkill'
import {track} from '../../utils/eventTracking/track'

export interface Option {
  value: string
  text: string
}

interface Props {
  title: string
  options?: Option[]
  setSelectedOption?: (option: Option) => void
  selectedOption?: Option
  onOpenHelpModal?: () => void
}

const SkillOptions = ({
  title,
  options,
  setSelectedOption,
  selectedOption,
  onOpenHelpModal,
}: Props) => {
  const theme = useTheme()
  const isMobile = useIsMobile()
  const {t} = useTranslation('common')

  const {skill} = useSkill()

  const components = []

  if (options && selectedOption && setSelectedOption) {
    components.push(
      <Select
        key='s'
        background={theme.colors.layers.appLevel2}
        value={selectedOption.value}
        onChange={e => setSelectedOption(options[e.target.options.selectedIndex])}
        size='md'
        w='fit-content'
        h='2rem'
        borderRadius='full'
        mx={isMobile ? 0 : 2}
        my={isMobile ? 2 : 0}>
        {options.map(option => (
          <option value={option.value} color={theme.colors.brand.white} key={option.value}>
            {option.text}
          </option>
        ))}
      </Select>
    )
  }

  return (
    <HStack overflowY='auto' w='full'>
      <Box
        color={theme.colors.brand.white}
        w='full'
        display='flex'
        alignItems='center'
        columnGap={1}
        flexWrap='wrap'
        overflowY='auto'>
        <Trans i18nKey={title} components={components} />
      </Box>
      {onOpenHelpModal && (
        <Box h='full'>
          <Button
            variant='textLightPrimary'
            rightIcon={<FontAwesomeIcon icon={faCircleQuestion} />}
            onClick={() => {
              onOpenHelpModal && onOpenHelpModal()
              track(`feature-${skill.skillName}-help-modal`)
            }}>
            {t('help_button')}
          </Button>
        </Box>
      )}
    </HStack>
  )
}
export default SkillOptions
